/** How deep to look for the Finish page: the study's runner holds its own frames. */
const MAX_FRAME_DEPTH = 4;

/** True if `source` is `root` or a frame nested inside it (frame lists are readable cross-origin). */
export function isWithinFrame(source: MessageEventSource | null, root: Window, depth = 0): boolean {
  if (!source) return false;
  if (source === root) return true;
  if (depth >= MAX_FRAME_DEPTH) return false;
  for (let i = 0; i < root.frames.length; i += 1) {
    if (isWithinFrame(source, root.frames[i], depth + 1)) return true;
  }
  return false;
}
